import RestResource from '../rest.service';
import Service from '../api.service';

export default class ProducersService extends RestResource {
  map(entity) {
    return {
      business_name: entity.businessName,
      cuit: entity.cuit,
      distributor_id: typeof entity.distributor === 'object' ? entity.distributor.id : entity.distributor,
      email: entity.email,
      phone: entity.phone,
      address: entity.address,
      city_id: typeof entity.city === 'object' ? entity.city.id : entity.city,
      owned_hectares: entity.ownedHectares,
      leased_hectares: entity.leasedHectares,
      corn: entity.corn,
      storage_corn: entity.storageCorn,
      alfalfa: entity.alfalfa,
    };
  }

  search(params) {
    return Service.get(`${this.getResource()}/search`, { params }).catch(this.handleErrors);
  }

  getExportProducers() {
    return Service.get(`${this.getResource()}-export`, {
      responseType: 'blob',
    }).catch(this.handleErrors);
  }

  constructor() {
    super('producers');
  }
}
